const insurancePlanBlocked: { [key: number]: boolean } = Object.freeze({
  1: false,
  2: false,
  3: false,
});

export default insurancePlanBlocked;
